import { render, staticRenderFns } from "./addLevel.vue?vue&type=template&id=bfcb45e2"
import script from "./addLevel.vue?vue&type=script&lang=js"
export * from "./addLevel.vue?vue&type=script&lang=js"
import style0 from "./addLevel.vue?vue&type=style&index=0&id=bfcb45e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports